import React from 'react';
interface ValueBadgeProps {
  icon: React.ReactNode;
  name: string;
  description: string;
  index: number;
}
export function ValueBadge({
  icon,
  name,
  description
}: ValueBadgeProps) {
  return <div data-component="COMP-13-ValueBadge" className="flex flex-col items-center text-center max-w-[140px]" data-id="element-262">
      <div className="w-20 h-20 rounded-full bg-white/15 flex items-center justify-center mb-3" data-id="element-263">
        <div className="text-white" data-id="element-264">{icon}</div>
      </div>
      <h4 className="text-base font-bold text-white mb-1" data-id="element-265">{name}</h4>
      <p className="text-sm text-white/70 leading-tight" data-id="element-266">{description}</p>
    </div>;
}